import { Component, OnInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DeviceRepo } from "../../repos/device.repo";
import { UserEntity } from "../../entities/user.entity";
import { UserRepo } from "../../repos/user.repo";
import { IMyDpOptions } from "mydatepicker";
import { CountriesList } from "../../enums/countries-list";

import { BsModalService, ModalOptions, BsModalRef } from "ngx-bootstrap/modal";
import { UserPreferencesService } from "../../services/user-preferences.service";
import { ModalWidget, PinEntity, PinGroupEntity } from "../../entities";
import { PinGroupRepo, PinRepo } from "../../repos";
import { AlertWidgetEnum, ModalWidgetEnum } from "../../enums";
import { AlertWidgetEventStruct } from "../../widgets";
import { ToasterService } from "angular2-toaster";

@Component({
  templateUrl: "./show.component.html",
})
export class UserShowComponent implements OnInit {
  public subscription: any;
  public pinGroups: Array<PinGroupEntity> = [];
  public pinned: PinEntity | null = null;

  public user: UserEntity;
  public userEdit: UserEntity;
  public state = { edit: false, accountEdit: false, emailEdit: false };
  public notification = { showLoading: false, message: "", iserror: false };
  public error = { error: false, msg: "" };
  public currentModal: any = {
    title: null,
    msg: null,
    confirmMsg: null,
    confirm: null,
    cancelMsg: null,
    cancel: null,
  };
  public modalRef: BsModalRef;
  public showNotes = false;
  public timezones = { current: [], defaults: {} };
  public myDatePickerOptions: IMyDpOptions = { dateFormat: "mm.dd.yyyy" };
  public model: any = { date: { year: 2018, month: 10, day: 9 } };
  public clist;
  public ddr;
  public ddc = { placeholder: "None Selected (Default USA)", search: true };
  public geoData = { search: true, locs: [] };
  public user_sub_version = "1.0";
  public user_sub_version_toggle = false;
  public ownerId: any;
  public subscriptionDetails = false;
  public subscription_level;
  public sub_end_date;
  public no_of_devices;
  public no_of_locations;
  public no_of_alerts;
  // Alerts monitored with no active subscription (Complimentary plan).
  public readonly complimentaryAlertLimit = 10;
  // Alerts monitored under the user's active plan (features.alerts.max),
  // falls back to the complimentary limit when the plan doesn't set one.
  public alertPlanLimit = 10;
  public alertPlanName: string | null = null;
  public monitoredAlerts: any[] = [];
  public subscriptionOnlyAlerts: any[] = [];
  public unmonitoredAlerts: any[] = [];
  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public modalService: BsModalService,
    public userRepo: UserRepo,
    public deviceRepo: DeviceRepo,
    public preferences: UserPreferencesService,
    public pinRepo: PinRepo,
    public pinGroupRepo: PinGroupRepo,
    public toasterService: ToasterService
  ) {
    this.timezones = {
      current: [],
      defaults: {
        "America/Chicago": "Chicago (Central)",
        "Pacific/Honolulu": "Honolulu (Hawaii)",
        "America/Anchorage": "Anchorage (Alaska)",
        "America/Los_Angeles": "Los Angeles (Pacific)",
        "America/Denver": "Denver (Mountain)",
        "America/Phoenix": "Arizona (Mountain No DST)",
        "America/New_York": "New York (Eastern)",
      },
    };
  }

  loadSubscriptions() {
    if (!this.user.extended.meta.subscription_details_loaded) {
      this.preferences.session.readyPromise.then(() => {
        this.user.extended.getSubscriptionDetailsPromise().then(() => { });
      });
    }
  }

  loadVersion() {
    if (this.preferences) {
      this.preferences.session.readyPromise.then(() => {
        this.user_sub_version = this.preferences.featureVersion(
          "user-sub-widget",
          "1.0"
        );
        this.user_sub_version_toggle =
          this.user_sub_version == "1.0" ? false : true;
      });
    }
  }

  toggleUserSubWidgetVersion(event) {
    event.preventDefault();
    this.user_sub_version = this.user_sub_version_toggle ? "2.0" : "1.0";
    this.preferences.setFeatureVersion(
      "user-sub-widget",
      this.user_sub_version
    );
    this.loadSubscriptions();
  }

  handleEvent(event) {
    console.log("HANDLE EVENT", event);
  }

  public pinDevice(event, modal) {
    event.preventDefault();
    if (this.pinned) {
      let dialog = new ModalWidget(
        "Pin: " + this.user.identifier,
        ModalWidgetEnum.MODAL_WIDGET__UPDATE,
        this.pinned,
        {
          edit: true,
          revert: false,
          confirmName: "Update",
          deleteName: "Unpin",
        },
        "shadowbox"
      );
      this.showModal(dialog, modal);
    } else {
      let pin = this.pinRepo.entity({});
      pin.group =
        this.pinGroups && this.pinGroups.length > 0
          ? this.pinGroups[0].sref()
          : null;
      pin.name = `User ${this.user.identifier}`;
      pin.description = "auto generated";
      pin.subject = this.user.sref();
      pin.meta.new = true;
      let dialog = new ModalWidget(
        "Pin: " + this.user.sref(),
        ModalWidgetEnum.MODAL_WIDGET__CREATE,
        pin,
        { edit: true, revert: false, confirmName: "Pin" },
        "shadowbox"
      );
      this.showModal(dialog, modal);
    }
  }

  showModal(current, modal, clickOut = false, customClass = "") {
    this.currentModal = current;
    if (!clickOut) {
      let config: ModalOptions = {
        backdrop: "static",
        keyboard: false,
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    } else {
      let config: ModalOptions = {
        class: customClass,
      };
      this.currentModal.modalRef = this.modalService.show(modal, config);
    }
  }

  checkPin() {
    this.pinGroups = [];
    this.pinGroupRepo
      .getListPromise({ expand: false, pins: true })
      .then((r: Array<PinGroupEntity>) => {
        this.pinGroups = r;
        this.pinGroups.sort((a: PinGroupEntity, b: PinGroupEntity) => {
          return a.identifier >= b.identifier ? 1 : -1;
        });
        // Check if pinned
        let sref = `ref.user.${this.user.identifier}`;
        for (let pinGroup in this.pinGroups) {
          if (this.pinGroups[pinGroup].pins) {
            for (let pin in this.pinGroups[pinGroup].pins) {
              if (this.pinGroups[pinGroup].pins[pin].subject == sref) {
                this.pinned = this.pinGroups[pinGroup].pins[pin];
                break;
              }
            }
          }
        }
      });
  }

  ngOnInit(): void {
    this.clist = CountriesList.list;
    this.loadVersion();
    this.subscription = this.activatedRoute.params.subscribe((params: any) => {
      this.userRepo.getEntityPromise(params.id).then((user: UserEntity) => {
        this.user = user;
        this.user.loadNotificationEmail();
        this.user.getLocationsPromise().then(() => {
          this.no_of_locations = this.user._nested.locations.items.length;
        });
        this.user.getDeviceAssociationsPromise().then(() => {
          this.no_of_devices =
            this.user._nested.deviceAssociations.items.length;
          // Alert cards read the device picker options from here.
          this.user.deviceAssociationPairs =
            this.user._nested.deviceAssociations.items.map((device: any) => {
              device.deviceCategory = device.raw.sensor.type.category;
              device.deviceId = device.sensor_identifier;
              device.deviceName = device.device_name;
              device.associationId = device.identifier;
              return device;
            });
        });
        // Alert cards read the plan code from here to gate Email/SMS/Critical.
        this.user
          .getUserSubcriptionInfo()
          .then((data: any) => {
            this.user.subscriptionTypeName = data;
          })
          .catch(() => {
            this.user.subscriptionTypeName = "Not Subscribed";
          });
        this.user.getSubscriptionDetailsPromise().then(() => {
          if (
            this.user.extended.subscriptions.subscriptions.items.length === 0
          ) {
            this.subscription_level = "Not Subscribed";
            return;
          }
          const filteredData =
            this.user.extended.subscriptions.subscriptions.items.filter(
              (i) => i.subscription_status === "active"
            );
          if (filteredData.length === 0) {
            this.subscription_level = "Not Subscribed";
          } else {
            filteredData.map((i) => {
              this.sub_end_date = i.subscription_end;
              this.user
                .getSubscriptionDefinition(i.subscription_type)
                .then((definition: any) => {
                  this.subscription_level = definition
                    ? definition.code
                    : "Not Subscribed";
                  this.applyAlertPlanLimit(definition);
                })
                .catch(() => {
                  this.subscription_level = "Unknown";
                });
            });
          }
        });
        this.user.getAlertsPromise().then(() => {
          this.no_of_alerts = this.user.extended.alerts.items.length;
          this.sortAlertsByWeight();
        });
        this.checkPin();
      });
    });
  }

  selectionChanged(e, device) {
    if (e.value[0]) {
      device.geo.countryCode = e.value[0].value;
    } else {
      device.geo.countryCode = "US";
    }
  }

  loadSettings() {
    return this.user.getUserSettingsPromise();
  }

  loadUserChannels() {
    if (!this.user.meta["channels"]) {
      this.user.getChannelsPromise();
    }
  }

  handleAlertEvent(event) {
    if (event instanceof AlertWidgetEventStruct) {
      let alertEvent: AlertWidgetEventStruct = event;
      if (
        alertEvent.event_alert_widget_type ==
        AlertWidgetEnum.ALERT_WIDGET__ALERT_ENTITY_DELETE
      ) {
        alertEvent.event_body.entity
          .delete()
          .then(() => {
            this.toasterService.pop("warning", "Alert", `Alert Deleted`);
          })
          .catch(() => {
            this.toasterService.pop("error", "Alert", `Alert Delete Failed`);
          });
        let index = this.user.extended.alerts.items.indexOf(
          alertEvent.event_body["entity"]
        );
        if (index > -1) {
          this.user.extended.alerts.items.splice(index, 1);
          this.sortAlertsByWeight();
        }
      }
    }
  }

  loadAlerts(refresh = false) {
    if (!this.user.extended || !this.user.extended.alerts || refresh) {
      this.user.extended.getAlertsPromise().then(() => {
        if (this.user.extended.alerts) {
          this.user.extended.alerts.queryable = false;
        }
        this.sortAlertsByWeight();
      });
    }
  }

  // Sorts alerts by weight ascending (nulls first, matching AlertRepo's own
  // default sort), then splits them into the "monitored" head and the
  // "not monitored" tail per the plan's alert limit.
  sortAlertsByWeight() {
    if (
      !this.user ||
      !this.user.extended ||
      !this.user.extended.alerts ||
      !this.user.extended.alerts.items
    ) {
      return;
    }

    const items: any[] = this.user.extended.alerts.items;
    const sorted = [...items].sort((a: any, b: any) => {
      const wA = a.weight == null ? -Infinity : a.weight;
      const wB = b.weight == null ? -Infinity : b.weight;
      return wA - wB;
    });
    items.splice(0, items.length, ...sorted);

    // monitoredAlerts: always monitored (within the complimentary limit).
    // subscriptionOnlyAlerts: monitored only while the paid plan is active.
    // unmonitoredAlerts: beyond the plan limit, never monitored.
    const freeLimit = Math.min(this.complimentaryAlertLimit, this.alertPlanLimit);
    this.monitoredAlerts = items.slice(0, freeLimit);
    this.subscriptionOnlyAlerts = items.slice(freeLimit, this.alertPlanLimit);
    this.unmonitoredAlerts = items.slice(this.alertPlanLimit);
  }

  // Raises the alert limit to the plan's features.alerts.max. With several
  // active subscriptions (e.g. plus + sms add-on) the highest limit wins, so
  // an add-on without an alert limit never lowers it.
  applyAlertPlanLimit(definition: any) {
    const max = Number(
      definition &&
      definition.features &&
      definition.features.alerts &&
      definition.features.alerts.max
    );
    if (max > this.alertPlanLimit) {
      this.alertPlanLimit = max;
      this.alertPlanName = definition.code;
      this.sortAlertsByWeight();
    }
  }

  addAlert(e: any, modal: any) {
    e.preventDefault();
    const newAlert = this.user.extended.alerts.repo.entity({});
    newAlert.meta["new"] = true;
    const dialog = new ModalWidget(
      "Create Alert",
      ModalWidgetEnum.MODAL_WIDGET__CREATE,
      newAlert,
      { edit: true },
      "shadowbox"
    );
    this.showModal(dialog, modal);
    if (this.currentModal.modalRef) {
      this.currentModal.modalRef.onHide.subscribe(() => {
        this.user.extended.getAlertsPromise().then(() => {
          this.sortAlertsByWeight();
        });
      });
    }
  }

  createAlerts(alertData: object, refresh = false) {
    if (!this.user.extended || !this.user.extended.alerts || refresh) {
      this.user.extended.postAlertsPromise(alertData).then(() => {
        if (this.user.extended.alerts) {
          this.user.extended.alerts.queryable = false;
        }
      });
    }
  }

  loadInfo(key) {
    switch (key) {
      case "n":
        if (!this.user._nested.notifications.data) {
          this.user.getNotificationsPromise();
        }
        break;
      case "a":
        if (!this.user._nested.alerts) {
          this.user.getAlertsPromise();
        }
        break;
      case "e":
        if (!this.user._nested.alertEvents) {
          this.user.getAlertEventsRecentSimplifiedPromise();
        }
        break;
      case "g":
        if (!this.user._nested.group) {
          this.user.getGroupPromise();
        }
        break;
      case "s":
        break;
    }
  }

  reloadAssocDevices() {
    this.user._nested.deviceAssociations = null;
    this.user.getLocationsPromise();
    this.user.getDeviceAssociationsPromise();
  }

  reloadLocations(e) {
    e.preventDefault();
    this.user._nested.locations = null;
    this.user.getLocationsPromise();
  }

  back(event) {
    event.preventDefault();
    this.router.navigateByUrl(`/portal/users/list`);
  }

  setNotification(inp = "", error = false, loading = false) {
    this.notification.message = inp;
    this.notification.iserror = error;
    if (!loading) {
      this.notification.showLoading = false;
    }
  }

  getNotificationStatus() {
    this.user.getNotificationStatus().catch((err) => {
      this.setNotification(
        "An error occured loading Notification Status",
        true
      );
    });
  }

  edit(event, type) {
    event.preventDefault();
    this.userEdit = this.user.clone();
    if (!this.userEdit.email && this.userEdit.display_name) {
      this.userEdit.email = this.userEdit.display_name;
    }
    if (!this.userEdit.notification_email) {
      this.userEdit.notification_email = this.user.notification_email || this.user.email;
    }
    if (type === 1) {
      this.state.edit = true;
      this.state.accountEdit = true;
    } else if (type === 2) {
      this.state.edit = true;
      this.state.emailEdit = true;
    }
  }

  deleteNotification(event, n) {
    event.preventDefault();
    this.user
      .deleteNotification(n.identifier)
      .then((res) => { })
      .catch((err) => {
        console.log(err);
        n.loading = false;
        this.setNotification("An error occured while trying to delete", true);
      });
  }

  exitEditMode() {
    this.state.edit = false;
    this.state.emailEdit = false;
    this.state.accountEdit = false;
  }

  cancel(event) {
    event.preventDefault();
    this.exitEditMode();
  }

  getAlertState(alert, event) {
    event.preventDefault();
    this.user.getAlertStatePromise(alert);
  }

  viewDevice(device, event) {
    event.preventDefault();
    this.router.navigateByUrl(
      `/portal/devices/show/${device.raw.sensor.id}/${this.user.identifier}`
    );
  }

  toggleDeviceDetails(device, bool = false) {
    if (bool == true && device.expanded) return;
    device.expanded = !device.expanded;
    if (!device.isfact23 && device.isStation && !device.geo["called"]) {
      device.getGeo();
    }
  }

  toggleNotificationRaw(notification) {
    notification.showRaw = !notification.showRaw;
  }

  toggleAlertStatus(alert) {
    alert.expanded = !alert.expanded;
  }

  getDeviceStatus(device, event) {
    event.preventDefault();
    device.getStatusPromise();
  }

  public batterySettingFields = [
    { key: "enabled", label: "Enabled", boolean: true },
    { key: "push", label: "Push", boolean: true },
    { key: "in_app", label: "In-App", boolean: true },
    { key: "email", label: "Email", boolean: true },
    { key: "sms", label: "SMS", boolean: true },
    { key: "source", label: "Source", boolean: false },
  ];

  getLowBatteryWarnings(device, event) {
    event.preventDefault();
    device.getBatteryNotificationSettingsPromise();
  }

  addDevice() {
    this.user.addEmptyDeviceAssociation();
  }

  testChannel(c) {
    c.loading = true;
    this.user
      .testChannel(c.identifier)
      .then((r) => {
        c.loading = false;
        this.setNotification("Successful test initiated");
      })
      .catch((e) => {
        console.log(e);
        c.loading = false;
        this.setNotification(
          "An error occured trying to test this channel",
          true
        );
      });
  }

  addLocation() {
    this.user.addEmptyLocation();
  }

  createLocation(l, event) {
    event.preventDefault();
    l.saving = true;
    l.createLocation().then((res: any) => {
      this.user.getLocationsPromise();
    });
  }

  reposLocation(e, l) {
    e.preventDefault();
    if (l.newPos != null) {
      l.saving = true;
      l.reposition(l.newPos).then((res: any) => {
        this.user.getLocationsPromise();
      });
    } else {
      this.setNotification("New location not selected", true);
    }
  }

  /** Drag-and-drop state for Location */
  public locationDraggedId: string = null;
  public locationDraggedWeight: number = null;
  public locationPreview: { beforeId: any } = null;
  public locationDragName = "";
  public locationDragHeight = 0;
  public locationPreviewHint = "";
  private locationDragOrigin: { beforeId: any } = null;
  private locationDragSource: HTMLElement = null;
  private locationPreviewChangedAt = 0;

  onLocationDragStart(e: DragEvent, location: any) {
    this.locationDraggedId = location.identifier;
    this.locationDraggedWeight = location.weight;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", location.identifier);

    const col = e.currentTarget as HTMLElement;
    const card = col.querySelector(".card") as HTMLElement;
    this.locationDragSource = col;
    this.locationDragHeight = card ? card.offsetHeight : col.offsetHeight;
    this.locationDragName = location.name || ("Location " + location.identifier);
    const siblings = (this.user._nested.locations?.items || []).filter(
      (l) => l.identifier !== "new"
    );
    const next = siblings[siblings.indexOf(location) + 1];
    this.locationDragOrigin = {
      beforeId: next ? next.identifier : null,
    };
    setTimeout(() => {
      if (this.locationDraggedId === location.identifier) {
        this.setLocationPreview(this.locationDragOrigin);
      }
    }, 0);
  }

  onLocationDragEnd(e: DragEvent) {
    this.locationDraggedId = null;
    this.locationDraggedWeight = null;
    this.locationDragSource = null;
    this.clearLocationPreview();
  }

  onLocationDragOver(e: DragEvent) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }

  onLocationCardDragOver(e: DragEvent, target: any) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (!this.locationPreview || target.identifier === this.locationDraggedId) {
      return;
    }
    if (Date.now() - this.locationPreviewChangedAt < 150) return;

    const rest = (this.user._nested.locations?.items || []).filter(
      (l) => l.identifier !== "new" && l.identifier !== this.locationDraggedId
    );
    const t = rest.indexOf(target);
    if (t < 0) return;

    let p = t;
    p = t >= this.locationPreviewIndex(rest) ? t + 1 : t;
    this.setLocationPreview({
      beforeId: p < rest.length ? rest[p].identifier : null,
    });
  }

  onLocationShadowDrop(e: DragEvent) {
    e.preventDefault();
    const preview = this.locationPreview;
    if (!preview || !this.locationDraggedId) return;

    const all = (this.user._nested.locations?.items || []).filter(
      (l) => l.identifier !== "new"
    );
    const dragged = all.find((l) => l.identifier === this.locationDraggedId);
    const rest = all.filter((l) => l !== dragged);
    const p = this.locationPreviewIndex(rest);
    this.clearLocationPreview();

    if (dragged) {
      if (all[p] !== dragged) this.onLocationDrop(e, all[p]);
    } else if (p < rest.length) {
      this.onLocationDrop(e, rest[p]);
    }
  }

  isLocationShadowAtEnd(): boolean {
    return !!this.locationPreview && this.locationPreview.beforeId === null;
  }

  private locationPreviewIndex(rest: any[]): number {
    const i = rest.findIndex(
      (l) => l.identifier === this.locationPreview.beforeId
    );
    return i < 0 ? rest.length : i;
  }

  private setLocationPreview(preview: { beforeId: any }) {
    const current = this.locationPreview;
    if (current && current.beforeId === preview.beforeId) {
      return;
    }
    this.locationPreview = preview;
    this.locationPreviewChangedAt = Date.now();

    const origin = this.locationDragOrigin;
    this.locationPreviewHint =
      origin && origin.beforeId === preview.beforeId
        ? "Current position"
        : "Will move here";
  }

  private clearLocationPreview() {
    this.locationPreview = null;
    this.locationDragOrigin = null;
  }

  onLocationDrop(e: DragEvent, targetLocation: any) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.locationDraggedId || this.locationDraggedId === targetLocation.identifier) {
      return;
    }
    const items: any[] = this.user._nested.locations.items;
    const draggedLocation = items.find(l => l.identifier === this.locationDraggedId);
    if (!draggedLocation) return;

    draggedLocation.saving = true;
    draggedLocation
      .reposition(targetLocation.identifier, targetLocation.weight)
      .then(() => {
        this.user.getLocationsPromise();
        draggedLocation.saving = false;
      })
      .catch(() => {
        this.setNotification("Failed to reorder location", true);
        draggedLocation.saving = false;
      });
  }



  getDevicesForLocation(locationId: string): any[] {
    if (!this.user || !this.user._nested || !this.user._nested.deviceAssociations || !this.user._nested.deviceAssociations['items']) {
      return [];
    }
    return this.user._nested.deviceAssociations['items'].filter(dev => dev.identifier !== 'new' && String(dev.location_id) === String(locationId));
  }

  getNewDevices(): any[] {
    if (!this.user || !this.user._nested || !this.user._nested.deviceAssociations || !this.user._nested.deviceAssociations['items']) {
      return [];
    }
    return this.user._nested.deviceAssociations['items'].filter(dev => dev.identifier === 'new');
  }

  /** Device Drag-and-drop state & handlers */
  public deviceDraggedId: string = null;
  public deviceDraggedWeight: number = null;
  /** Set while the mouse is held on a drag handle; makes its card draggable. */
  public deviceHandleActive: string = null;

  /**
   * Shadow shown in place of the dragged device card: the slot the device
   * lands in if dropped now. beforeId is the device the shadow sits in front
   * of, or null for the end of that location's list.
   */
  public devicePreview: { locationId: any; beforeId: any } = null;
  public deviceDragName = "";
  public deviceDragHeight = 0;
  public devicePreviewHint = "";
  private deviceDragOrigin: { locationId: any; beforeId: any } = null;
  private deviceDragSource: HTMLElement = null;
  private devicePreviewChangedAt = 0;

  public lastDragY: number = null;
  public autoScrollInterval: any = null;

  @HostListener('document:dragover', ['$event'])
  onDocumentDragOver(e: DragEvent) {
    this.lastDragY = e.clientY;

    if ((this.deviceDraggedId || this.alertDraggedId || this.locationDraggedId) && !this.autoScrollInterval) {
      this.autoScrollInterval = setInterval(() => {
        if (this.deviceDragSource && !document.body.contains(this.deviceDragSource)) {
          // The device list was re-rendered mid-drag, so this drag's dragend
          // can no longer reach us: end it here or the shadow would stay.
          this.onDeviceDragEnd(null);
          this.onDocumentDragEndGlobal(null);
          return;
        }
        if (this.locationDragSource && !document.body.contains(this.locationDragSource)) {
          this.onLocationDragEnd(null);
          this.onDocumentDragEndGlobal(null);
          return;
        }
        if (this.alertDragSource && !document.body.contains(this.alertDragSource)) {
          this.onAlertDragEnd(null);
          this.onDocumentDragEndGlobal(null);
          return;
        }
        if (this.lastDragY !== null) {
          const threshold = 100;
          const scrollSpeed = 25;
          let scrollContainer = document.querySelector('html');
          let mainContainer = document.querySelector('.main');

          if (this.lastDragY < threshold) {
            window.scrollBy(0, -scrollSpeed);
            if (mainContainer) mainContainer.scrollTop -= scrollSpeed;
          } else if (window.innerHeight - this.lastDragY < threshold) {
            window.scrollBy(0, scrollSpeed);
            if (mainContainer) mainContainer.scrollTop += scrollSpeed;
          }
        }
      }, 20);
    }
  }

  @HostListener('document:dragend', ['$event'])
  onDocumentDragEndGlobal(e: DragEvent) {
    this.lastDragY = null;
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }

  onDeviceDragStart(e: DragEvent, device: any) {
    this.deviceDraggedId = device.identifier;
    this.deviceDraggedWeight = device.weight;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", device.identifier);

    const col = e.currentTarget as HTMLElement;
    const card = col.querySelector(".card") as HTMLElement;
    this.deviceDragSource = col;
    this.deviceDragHeight = card ? card.offsetHeight : col.offsetHeight;
    this.deviceDragName = device.raw.name;
    const siblings = this.getDevicesForLocation(device.location_id);
    const next = siblings[siblings.indexOf(device) + 1];
    this.deviceDragOrigin = {
      locationId: device.location_id,
      beforeId: next ? next.identifier : null,
    };
    // Swap the card for its shadow only after the browser has taken the drag
    // image: hiding the card inside dragstart would cancel the drag.
    setTimeout(() => {
      if (this.deviceDraggedId === device.identifier) {
        this.setDevicePreview(this.deviceDragOrigin);
      }
    }, 0);
  }

  onDeviceDragEnd(e: DragEvent) {
    this.deviceDraggedId = null;
    this.deviceDraggedWeight = null;
    this.deviceDragSource = null;
    this.deviceHandleActive = null;
    this.clearDevicePreview();
  }

  onDeviceDragOver(e: DragEvent) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }

  /** Dragging over a device card: the shadow takes that card's slot. */
  onDeviceCardDragOver(e: DragEvent, target: any) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (!this.devicePreview || target.identifier === this.deviceDraggedId) {
      return;
    }
    // Let the cards settle after the last shift before reacting again.
    if (Date.now() - this.devicePreviewChangedAt < 150) return;

    const locationId = target.location_id;
    const rest = this.getDevicesForLocation(locationId).filter(
      (d) => d.identifier !== this.deviceDraggedId
    );
    const t = rest.indexOf(target);
    if (t < 0) return;
    // Arriving from another location the shadow goes in front of the card;
    // within a location it swaps sides with the card, so it always ends up
    // in the slot under the cursor and the cards in between shift over.
    let p = t;
    if (String(this.devicePreview.locationId) === String(locationId)) {
      p = t >= this.devicePreviewIndex(rest) ? t + 1 : t;
    }
    this.setDevicePreview({
      locationId: locationId,
      beforeId: p < rest.length ? rest[p].identifier : null,
    });
  }

  /** Dragging over a location outside its cards (heading, empty space). */
  onDeviceZoneDragOver(e: DragEvent, locationId: any) {
    if (!this.devicePreview) return;
    const el = e.target as HTMLElement;
    // Cards and the shadow itself are handled on their own.
    if (el && el.closest && el.closest(".device-drag-item")) return;
    // Already in this location: keep the slot the shadow has.
    if (String(this.devicePreview.locationId) === String(locationId)) return;
    if (Date.now() - this.devicePreviewChangedAt < 150) return;

    // Back in its own location nothing changes; in another location the
    // device goes to the end of the list (see onDeviceDropToLocation).
    const home = String(this.deviceDragOrigin.locationId) === String(locationId);
    this.setDevicePreview(
      home ? this.deviceDragOrigin : { locationId: locationId, beforeId: null }
    );
  }

  /**
   * Drop anywhere in the devices area. The reorder itself is still done by
   * onDeviceDrop / onDeviceDropToLocation: this only picks the target that
   * matches the slot the shadow is in.
   */
  onDeviceShadowDrop(e: DragEvent) {
    e.preventDefault();
    const preview = this.devicePreview;
    if (!preview || !this.deviceDraggedId) return;

    const all = this.getDevicesForLocation(preview.locationId);
    const dragged = all.find((d) => d.identifier === this.deviceDraggedId);
    const rest = all.filter((d) => d !== dragged);
    const p = this.devicePreviewIndex(rest);
    this.clearDevicePreview();

    if (dragged) {
      // Same location: onDeviceDrop puts the dragged device in its target's
      // slot, so the target is whichever device holds the shadow's slot now.
      if (all[p] !== dragged) this.onDeviceDrop(e, all[p]);
    } else {
      // Cross-location: sort target devices by weight and place at specific slot
      const sortedRest = [...rest].sort(
        (a, b) => (Number(a.weight) || 0) - (Number(b.weight) || 0)
      );
      this.onDeviceMoveToLocationSlot(preview.locationId, p, sortedRest);
    }
  }

  /**
   * Handles cross-location device placement matching mobile app behavior:
   * - At the end (or empty location): update location only (server automatically assigns maxWeight + 100).
   * - In between devices (p > 0): update location, then rankAfter the device directly before the slot.
   * - At the very top (p === 0): update location, then rankBefore the first device.
   */
  onDeviceMoveToLocationSlot(locationId: string, p: number, rest: any[]) {
    const items: any[] = this.user._nested.deviceAssociations?.items || [];
    const draggedDevice = items.find((d) => d.identifier === this.deviceDraggedId);
    if (!draggedDevice) return;

    draggedDevice.saving = true;
    draggedDevice.location_id = locationId;

    if (p <= 0 && rest.length > 0) {
      // Slot 0: rank before the first device
      const firstDevice = rest[0];
      draggedDevice
        .updateAssociation(this.user.identifier)
        .then(() =>
          draggedDevice.rankBefore(this.user.identifier, firstDevice.identifier)
        )
        .then(() => {
          setTimeout(() => this.user.getDeviceAssociationsPromise(), 1500);
          draggedDevice.saving = false;
        })
        .catch(() => {
          this.setNotification("Failed to move and reorder device", true);
          draggedDevice.saving = false;
        });
    } else if (p > 0 && p < rest.length) {
      // In between devices: rank after the preceding device (rest[p - 1])
      const prevDevice = rest[p - 1];
      draggedDevice
        .updateAssociation(this.user.identifier)
        .then(() =>
          draggedDevice.rankAfter(this.user.identifier, prevDevice.identifier)
        )
        .then(() => {
          setTimeout(() => this.user.getDeviceAssociationsPromise(), 1500);
          draggedDevice.saving = false;
        })
        .catch(() => {
          this.setNotification("Failed to move and reorder device", true);
          draggedDevice.saving = false;
        });
    } else {
      // Dropped at the end (or into empty location): 0 for empty location, or maxWeight + 100
      let targetWeight = 0;
      if (rest.length > 0) {
        const maxWeight = Math.max(...rest.map((d) => Number(d.weight) || 0));
        targetWeight = maxWeight + 100;
      }
      draggedDevice.weight = targetWeight;
      draggedDevice
        .updateAssociation(this.user.identifier, targetWeight)
        .then(() => {
          setTimeout(() => this.user.getDeviceAssociationsPromise(), 1500);
          draggedDevice.saving = false;
        })
        .catch(() => {
          this.setNotification("Failed to move device to location", true);
          draggedDevice.saving = false;
        });
    }
  }

  isDeviceShadowAtEnd(locationId: any): boolean {
    return (
      !!this.devicePreview &&
      this.devicePreview.beforeId === null &&
      String(this.devicePreview.locationId) === String(locationId)
    );
  }

  /** Position of the shadow within a location's devices (dragged one excluded). */
  private devicePreviewIndex(rest: any[]): number {
    const i = rest.findIndex(
      (d) => d.identifier === this.devicePreview.beforeId
    );
    return i < 0 ? rest.length : i;
  }

  private setDevicePreview(preview: { locationId: any; beforeId: any }) {
    const current = this.devicePreview;
    if (
      current &&
      current.beforeId === preview.beforeId &&
      String(current.locationId) === String(preview.locationId)
    ) {
      return;
    }
    this.devicePreview = preview;
    this.devicePreviewChangedAt = Date.now();

    const origin = this.deviceDragOrigin;
    if (String(origin.locationId) === String(preview.locationId)) {
      this.devicePreviewHint =
        origin.beforeId === preview.beforeId
          ? "Current position"
          : "Will move here";
    } else {
      const location = this.user._nested.locations.items.find(
        (l) => String(l.identifier) === String(preview.locationId)
      );
      this.devicePreviewHint =
        "Will move to " + ((location && location.name) || "this location");
    }
  }

  private clearDevicePreview() {
    this.devicePreview = null;
    this.deviceDragOrigin = null;
  }

  onDeviceDrop(e: DragEvent, targetDevice: any) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.deviceDraggedId || this.deviceDraggedId === targetDevice.identifier) {
      return;
    }
    const items: any[] = this.user._nested.deviceAssociations?.items || [];
    const draggedDevice = items.find(d => d.identifier === this.deviceDraggedId);
    if (!draggedDevice) return;

    draggedDevice.saving = true;

    if (String(draggedDevice.location_id) !== String(targetDevice.location_id)) {
      const targetLocDevices = this.getDevicesForLocation(targetDevice.location_id)
        .sort((a, b) => (Number(a.weight) || 0) - (Number(b.weight) || 0));
      const targetIdx = targetLocDevices.findIndex(d => d.identifier === targetDevice.identifier);
      this.onDeviceMoveToLocationSlot(targetDevice.location_id, targetIdx >= 0 ? targetIdx : targetLocDevices.length, targetLocDevices);
    } else {
      draggedDevice
        .reposition(this.user.identifier, targetDevice.identifier, targetDevice.weight)
        .then(() => {
          this.user.getDeviceAssociationsPromise();
          draggedDevice.saving = false;
        })
        .catch(() => {
          this.setNotification("Failed to reorder device", true);
          draggedDevice.saving = false;
        });
    }
  }

  onDeviceDropToLocation(e: DragEvent, locationId: string) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.deviceDraggedId) return;

    const items: any[] = this.user._nested.deviceAssociations?.items || [];
    const draggedDevice = items.find(d => d.identifier === this.deviceDraggedId);
    if (!draggedDevice || String(draggedDevice.location_id) === String(locationId)) {
      return;
    }

    draggedDevice.saving = true;
    draggedDevice.location_id = locationId;

    const devicesInTarget = this.getDevicesForLocation(locationId);
    let targetWeight = 0;
    if (devicesInTarget.length > 0) {
      const maxWeight = Math.max(...devicesInTarget.map(d => Number(d.weight) || 0));
      targetWeight = maxWeight + 100;
    }
    draggedDevice.weight = targetWeight;

    // Moving to the location at the end: updateAssociation with targetWeight
    draggedDevice.updateAssociation(this.user.identifier, targetWeight)
      .then(() => {
        setTimeout(() => this.user.getDeviceAssociationsPromise(), 1500);
        draggedDevice.saving = false;
      })
      .catch(() => {
        this.setNotification("Failed to move device to location", true);
        draggedDevice.saving = false;
      });
  }

  /** Alert Drag-and-drop state & handlers */
  public alertDraggedId: string = null;
  public alertDraggedWeight: number = null;
  public alertPreview: { beforeId: any } = null;
  public alertDragName = "";
  public alertDragHeight = 0;
  public alertPreviewHint = "";
  private alertDragOrigin: { beforeId: any } = null;
  private alertDragSource: HTMLElement = null;
  private alertPreviewChangedAt = 0;

  onAlertDragStart(e: DragEvent, alert: any) {
    this.alertDraggedId = alert.identifier;
    this.alertDraggedWeight = alert.weight;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", alert.identifier);

    const col = e.currentTarget as HTMLElement;
    const widget = (col.querySelector(".alert-widget") || col.querySelector(".card") || col) as HTMLElement;
    this.alertDragSource = col;
    this.alertDragHeight = widget ? widget.offsetHeight : col.offsetHeight;
    this.alertDragName = alert.name || (alert.raw && alert.raw.name) || alert.identifier;
    const siblings: any[] = this.user.extended?.alerts?.items || [];
    const next = siblings[siblings.indexOf(alert) + 1];
    this.alertDragOrigin = {
      beforeId: next ? next.identifier : null,
    };
    setTimeout(() => {
      if (this.alertDraggedId === alert.identifier) {
        this.setAlertPreview(this.alertDragOrigin);
      }
    }, 0);
  }

  onAlertDragEnd(e: DragEvent) {
    this.alertDraggedId = null;
    this.alertDraggedWeight = null;
    this.alertDragSource = null;
    this.clearAlertPreview();
  }

  onAlertDragOver(e: DragEvent) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }

  onAlertCardDragOver(e: DragEvent, target: any) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (!this.alertPreview || target.identifier === this.alertDraggedId) {
      return;
    }
    if (Date.now() - this.alertPreviewChangedAt < 150) return;

    const allAlerts: any[] = this.user.extended?.alerts?.items || [];
    const rest = allAlerts.filter((a) => a.identifier !== this.alertDraggedId);
    const t = rest.indexOf(target);
    if (t < 0) return;

    let p = t;
    p = t >= this.alertPreviewIndex(rest) ? t + 1 : t;
    this.setAlertPreview({
      beforeId: p < rest.length ? rest[p].identifier : null,
    });
  }

  onAlertShadowDrop(e: DragEvent) {
    e.preventDefault();
    const preview = this.alertPreview;
    if (!preview || !this.alertDraggedId) return;

    const all: any[] = this.user.extended?.alerts?.items || [];
    const dragged = all.find((a) => a.identifier === this.alertDraggedId);
    const rest = all.filter((a) => a !== dragged);
    const p = this.alertPreviewIndex(rest);
    this.clearAlertPreview();

    if (dragged) {
      if (all[p] !== dragged) this.onAlertDrop(e, all[p]);
    } else if (p < rest.length) {
      this.onAlertDrop(e, rest[p]);
    }
  }

  isAlertShadowAtEnd(section: string): boolean {
    if (!this.alertPreview || this.alertPreview.beforeId !== null) return false;
    if (this.unmonitoredAlerts && this.unmonitoredAlerts.length > 0) {
      return section === "unmonitored";
    }
    if (this.subscriptionOnlyAlerts && this.subscriptionOnlyAlerts.length > 0) {
      return section === "subscription";
    }
    return section === "monitored";
  }

  private alertPreviewIndex(rest: any[]): number {
    const i = rest.findIndex(
      (a) => a.identifier === this.alertPreview.beforeId
    );
    return i < 0 ? rest.length : i;
  }

  private setAlertPreview(preview: { beforeId: any }) {
    const current = this.alertPreview;
    if (current && current.beforeId === preview.beforeId) {
      return;
    }
    this.alertPreview = preview;
    this.alertPreviewChangedAt = Date.now();

    const origin = this.alertDragOrigin;
    this.alertPreviewHint =
      origin && origin.beforeId === preview.beforeId
        ? "Current position"
        : "Will move here";
  }

  private clearAlertPreview() {
    this.alertPreview = null;
    this.alertDragOrigin = null;
  }

  onAlertDrop(e: DragEvent, targetAlert: any) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.alertDraggedId || this.alertDraggedId === targetAlert.identifier) {
      return;
    }
    const allAlerts: any[] = this.user.extended?.alerts?.items || [];
    const draggedAlert = allAlerts.find(a => a.identifier === this.alertDraggedId);
    if (!draggedAlert) return;

    const locId = targetAlert.raw?.locationId || targetAlert.sensor?.locationId || null;
    draggedAlert.meta.saving = true;
    draggedAlert
      .repositionAlert(this.user.identifier, locId, targetAlert.identifier, targetAlert.weight)
      .then(() => {
        this.loadAlerts(true);
        draggedAlert.meta.saving = false;
      })
      .catch(() => {
        this.setNotification("Failed to reorder alert", true);
        draggedAlert.meta.saving = false;
      });
  }


  listLinkedDevices(l) {
    let s = "";
    l.linkedDevices.forEach((item, index) => {
      if (index > 0) s += ", ";
      s += item;
    });
    this.setNotification(s);
  }

  editDevice(device, $event) {
    $event.preventDefault();
    this.geoData = { search: true, locs: [] };
    if (!device.isfact23) {
      if (!device.geo["called"]) {
        device.saving = true;
        device
          .getGeo()
          .then((res) => {
            device.saving = false;
            device.editMode = true;
            device.editPrep();
          })
          .catch((err) => {
            device.editMode = true;
            device.saving = false;
          });
      } else {
        device.editPrep();
        device.editMode = true;
      }
    } else {
      this.ddr = null;
      device.editPrep();
      if (
        device.isStation &&
        device.raw.sensor.geo &&
        device.raw.sensor.geo.timezone
      ) {
        let temp = device.raw.sensor.geo.timezone;
        this.timezones.current = [temp];
      } else if (device.geo) {
        device.geo.timezone = "America/Chicago";
      }
      device.editMode = true;
    }
  }

  cancelEditDevice(device, $event) {
    $event.preventDefault();
    device.cancelEdit();
    device.editMode = false;
  }

  updateDeviceAssociation(device, $event) {
    $event.preventDefault();
    device.saving = true;
    device.updateAssociation(this.user.identifier).then((res) => {
      if (res) {
        this.user.getDeviceAssociationsPromise();
      } else {
        device.saving = false;
        this.setNotification("Something failed", true);
      }
    });
  }

  updateDeviceGeoLegacy(device, $event) {
    $event.preventDefault();
    if (device.geo.anonymous || (device.geo.timezone && device.geo.pc)) {
      device.saving = true;
      device.updateGeoLegacy().then((res) => {
        if (res) {
          this.user.getDeviceAssociationsPromise();
        } else {
          device.saving = false;
          this.setNotification("Something failed", true);
        }
      });
    } else {
      this.setNotification(
        "Must be Anonymous, or have zip and timezone filled in",
        true
      );
      device.saving = false;
    }
  }

  getGeoCode(device, $event) {
    $event.preventDefault();
    if (device.geo.pc && device.geo.pc.length > 0) {
      device.saving = true;
      device.searchGeoCode().then((res) => {
        device.saving = false;
        this.geoData.locs = res["locations"];
        this.geoData.search = false;
      });
    } else {
      this.setNotification("No postal code provided", true);
      device.saving = false;
    }
  }

  assignGeo(d, l, e) {
    d.saving = true;
    e.preventDefault();
    d.assignGeo(l.acw_key, l.country_code, l.tz_name)
      .then((res) => {
        d.saving = false;
        this.user.getDeviceAssociationsPromise();
      })
      .catch((err) => {
        d.saving = false;
      });
  }

  checkDevice(device, event) {
    if (event) {
      event.preventDefault();
    }
    if (device.checking) {
      return;
    }
    if (device.sensor_serial && device.sensor_serial.trim().length == 6) {
      device.checking = true;
      device.sensor_serial = device.sensor_serial.trim();
      this.deviceRepo
        .getBySerialPromise(device.sensor_serial, {})
        .then((res) => {
          device.checking = false;
          device.sensor_identifier = res["identifier"];
          if (res["attributes"] && res["attributes"]["display"] === "1") {
            device.sensor = {
              geo: { anonymous: true, zip: 0, timezone: "America/Chicago" },
            };
            device.status = true;
          } else {
            device.status = true;
          }
        })
        .catch((err) => {
          device.checking = false;
          this.setNotification(
            "Failed to check device: " + (err && err.message ? err.message : "Not found"),
            true
          );
        });
    } else {
      this.setNotification("Invalid Serial", true);
    }
  }

  updateAlert(a) {
    a.saving = true;
    a.update()
      .then((ret) => {
        a.saving = false;
        a.editMode = false;
      })
      .catch((err) => {
        a.saving = false;
      });
  }

  createDevice(device, event) {
    if (event) {
      event.preventDefault();
    }
    if (device.saving) {
      return;
    }
    const hasLocation =
      device.location_id &&
      (String(device.location_id).length > 1 || Number(device.location_id) > 0);
    if (!hasLocation) {
      this.setNotification("Location must be set", true);
      return;
    }

    device.saving = true;
    this.setNotification();
    device
      .createAssociation(this.user.identifier)
      .then((res) => {
        if (res) {
          this.setNotification("Device linked successfully");
          this.user
            .getDeviceAssociationsPromise()
            .then(
              () => {
                device.saving = false;
              },
              () => {
                device.saving = false;
              }
            );
        } else {
          this.setNotification(
            "Something failed on creation, it is unknown if the device was added successfully",
            true
          );
          device.saving = false;
        }
      })
      .catch((err) => {
        console.error("Error creating device association", err);
        this.setNotification(
          "Error creating device association: " +
          (err && err.message ? err.message : "Failed"),
          true
        );
        device.saving = false;
      });
  }

  save(confirmModal, event) {
    event.preventDefault();
    this.setNotification();
    this.currentModal = {
      title: "Confirm Update User Record",
      msg: `Are you sure you want to make these changes?`,
      confirmMsg: "Yes, Proceed",
      confirm: () => {
        this.modalRef.hide();
        this.notification.showLoading = true;
        this.userEdit
          .savePromise()
          .then((result: UserEntity) => {
            const preservedNotifEmail = this.user.notification_email;
            this.user.refresh(result.toJson());
            if (preservedNotifEmail) {
              this.user.notification_email = preservedNotifEmail;
            }
            this.exitEditMode();
            this.setNotification("Success");
          })
          .catch((err: any) => {
            console.log(err);
            this.setNotification("an error occured", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  saveEmail(confirmModal, event) {
    this.setNotification();
    event.preventDefault();

    const oldAccountEmail = (this.user.email || this.user.display_name || "").trim();
    const newAccountEmail = (this.userEdit.email || this.userEdit.display_name || "").trim();
    const oldNotifEmail = (this.user.notification_email || this.user.email || "").trim();
    const newNotifEmail = (this.userEdit.notification_email || "").trim();

    const accountEmailChanged = newAccountEmail !== oldAccountEmail;
    const notifEmailChanged = newNotifEmail !== oldNotifEmail;

    if (!accountEmailChanged && !notifEmailChanged) {
      this.toasterService.pop("info", "No Changes", "No changes were made to emails.");
      this.exitEditMode();
      return;
    }

    if (accountEmailChanged && (!newAccountEmail || newAccountEmail.indexOf("@") === -1)) {
      this.toasterService.pop("error", "Invalid Email", "Please enter a valid Account Email.");
      return;
    }

    if (notifEmailChanged && (!newNotifEmail || newNotifEmail.indexOf("@") === -1)) {
      this.toasterService.pop("error", "Invalid Email", "Please enter a valid Notification Email.");
      return;
    }

    let title = "";
    let msg = "";

    if (accountEmailChanged && notifEmailChanged) {
      title = "Confirm Update Emails";
      msg = `Are you sure you want to update both emails?\n\n• Account Email will be updated to: ${newAccountEmail}\n• Notification Email will be updated to: ${newNotifEmail}\n\nAlerts will go to this notification email.`;
    } else if (notifEmailChanged) {
      title = "Confirm Notification Email Update";
      msg = `Are you sure you want to update Notification Email to ${newNotifEmail}? Alerts will go to this email.`;
    } else {
      title = "Confirm Account Email Update";
      msg = `Are you sure you want to update Account Email to ${newAccountEmail}?`;
    }

    const extractErrorMessage = (err: any, fallback: string): string => {
      if (err && err.details && err.details.error) {
        if (typeof err.details.error === "string") {
          return err.details.error;
        }
        if (err.details.error.error) {
          return err.details.error.error;
        }
        if (err.details.error.message) {
          return err.details.error.message;
        }
      }
      if (err && err.message && err.message !== "request error") {
        return err.message;
      }
      return fallback;
    };

    this.currentModal = {
      title: title,
      msg: msg,
      confirmMsg: "Yes, Proceed",
      confirm: () => {
        this.notification.showLoading = true;
        this.modalRef.hide();

        const updateNotif = () => {
          if (!notifEmailChanged) {
            return Promise.resolve({ success: true });
          }
          return this.userEdit.updateNotificationEmail(newNotifEmail);
        };

        const updateAccount = () => {
          if (!accountEmailChanged) {
            return Promise.resolve({ success: true });
          }
          return this.userEdit.updateAccountEmail(newAccountEmail);
        };

        if (accountEmailChanged && notifEmailChanged) {
          updateAccount()
            .then(() => updateNotif())
            .then(() => {
              this.notification.showLoading = false;
              this.user.email = newAccountEmail;
              this.user.display_name = newAccountEmail;
              this.user.notification_email = newNotifEmail;
              this.exitEditMode();
              this.setNotification("Success");
              this.toasterService.pop(
                "success",
                "Emails Updated",
                `Account email and notification email updated successfully.`
              );
            })
            .catch((err: any) => {
              this.notification.showLoading = false;
              const errMsg = extractErrorMessage(err, "Error updating emails");
              this.setNotification(errMsg, true);
              this.toasterService.pop("error", "Error Occurred", errMsg);
              console.log(err);
              this.exitEditMode();
            });
        } else if (notifEmailChanged) {
          updateNotif()
            .then(() => {
              this.notification.showLoading = false;
              this.user.notification_email = newNotifEmail;
              this.exitEditMode();
              this.setNotification("Success");
              this.toasterService.pop(
                "success",
                "Notification Email Updated",
                `Notification email updated. Alerts will go to this email.`
              );
            })
            .catch((err: any) => {
              this.notification.showLoading = false;
              const errMsg = extractErrorMessage(
                err,
                "An error occurred while updating the notification email"
              );
              this.setNotification(errMsg, true);
              this.toasterService.pop("error", "Update Failed", errMsg);
              console.log(err);
              this.exitEditMode();
            });
        } else {
          updateAccount()
            .then(() => {
              this.notification.showLoading = false;
              this.user.email = newAccountEmail;
              this.user.display_name = newAccountEmail;
              this.exitEditMode();
              this.setNotification("Success");
              this.toasterService.pop(
                "success",
                "Account Email Updated",
                `Account email updated successfully.`
              );
            })
            .catch((err: any) => {
              this.notification.showLoading = false;
              const errMsg = extractErrorMessage(
                err,
                "Error updating account email"
              );
              this.setNotification(errMsg, true);
              this.toasterService.pop("error", "Error Occurred", errMsg);
              console.log(err);
              this.exitEditMode();
            });
        }
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };

    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }
  deleteAlert(confirmModal, alert, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm Delete Alert",
      msg: `Are you sure you want to delete this Alert?`,
      confirmMsg: "Yes, Proceed",
      confirm: () => {
        this.notification.showLoading = true;
        this.modalRef.hide();
        alert
          .delete()
          .then((res) => {
            this.user.getAlertsPromise();
            this.setNotification("Success");
          })
          .catch((err: any) => {
            this.setNotification("failed", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  deleteAssoc(confirmModal, device, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm Delete Device from account",
      msg: `Are you sure you want to delete this device?`,
      confirmMsg: "Yes, Proceed",
      confirm: () => {
        this.modalRef.hide();
        this.notification.showLoading = true;
        device.saving = true;
        device
          .deleteAssociation()
          .then((res) => {
            this.user.getDeviceAssociationsPromise();
            this.setNotification("Success");
          })
          .catch((err) => {
            console.log(err);
            device.saving = false;
            this.user.getDeviceAssociationsPromise();
            this.setNotification("Something went wrong", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  deleteLocation(confirmModal, location, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm Delete this Location",
      msg: `Are you sure you want to delete this location?`,
      confirmMsg: "Yes, Proceed",
      confirm: () => {
        this.modalRef.hide();
        location.saving = true;
        this.notification.showLoading = true;
        location
          .deleteLocation()
          .then((res) => {
            this.user.getLocationsPromise();
            this.setNotification("Success");
          })
          .catch((err) => {
            console.log(err);
            location.saving = false;
            this.user.getLocationsPromise();
            this.setNotification("Something went wrong", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  deleteSubscription(confirmModal, i, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm Delete subscription",
      msg: `Are you sure you want to delete this Subscription? This can not be undone.`,
      confirmMsg: "Yes, Delete subscription",
      confirm: () => {
        this.modalRef.hide();
        this.user._nested.subs.subscriptions[i]["saving"] = true;
        this.user
          .deleteSubscription(this.user._nested.subs.subscriptions[i])
          .then((res) => {
            alert(res);
            this.user.getUserSubcriptionInfo();
          })
          .catch((err) => {
            console.log(err);
            this.setNotification("Something went wrong", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  saveSubscription(i) {
    this.user._nested.subs.subscriptions[i]["saving"] = true;
    this.user
      .saveSubscription(this.user._nested.subs.subscriptions[i])
      .then((res) => {
        if (res && res["success"] == false) {
          this.setNotification("Failed", true);
        }
        this.user.getUserSubcriptionInfo();
      });
  }

  addNewSub() {
    let today = new Date();
    let end;
    if (today.getMonth() == 11) {
      end = new Date(today.getFullYear() + 1, 0, today.getDate());
    } else {
      end = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      );
    }
    this.user._nested.subs.subscriptions.push({
      isNew: true,
      edit: true,
      subscription_type: "ref.subscription.5361034439163904",
      subscription_start: {
        date: {
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          day: today.getDate(),
        },
      },
      subscription_end: {
        date: {
          year: end.getFullYear(),
          month: end.getMonth() + 1,
          day: end.getDate(),
        },
      },
      owner: "ref.user." + this.user.identifier,
    });
  }

  removeNewSubs() {
    let replace = [];
    for (let i of this.user._nested.subs.subscriptions) {
      if (!i.isNew) replace.push(i);
    }
    this.user._nested.subs.subscriptions = replace;
  }

  deleteThisUser(confirmModal, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm Delete This User",
      msg: `Are you sure you want to delete this User? This can not be undone.`,
      confirmMsg: "Yes, Delete this User",
      confirm: () => {
        this.modalRef.hide();
        this.user
          .deleteUser()
          .then((res) => {
            alert(res);
            this.setNotification(res.toString());
          })
          .catch((err) => {
            console.log(err);
            this.setNotification("Something went wrong", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }

  confirmSetAnon(confirmModal, device, event) {
    event.preventDefault();
    this.currentModal = {
      title: "Confirm set to Anonymous",
      msg: `Are you sure you want Set this device to Anonymous?`,
      confirmMsg: "Yes",
      confirm: () => {
        this.modalRef.hide();
        device.saving = true;
        device
          .assignGeo("", "")
          .then((res) => {
            this.user.getDeviceAssociationsPromise();
          })
          .catch((err) => {
            console.log(err);
            device.saving = false;
            this.setNotification("Something went wrong", true);
          });
      },
      cancelMsg: "No, Cancel",
      cancel: () => {
        this.modalRef.hide();
      },
    };
    let config: ModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    this.modalRef = this.modalService.show(confirmModal, config);
  }
}
